import { cn } from "@/lib/utils"

interface CustomerStatsCardProps {
  title: string
  value: string | number
  unit?: string
  color?: "green" | "red" | "orange"
  className?: string
}

export function CustomerStatsCard({ title, value, unit, color = "green", className }: CustomerStatsCardProps) {
  const colorClasses = {
    green: "text-brand-primary",
    red: "text-brand-light-red",
    orange: "text-orange-500",
  }

  const colorClass = colorClasses[color]

  return (
    <div className={cn("bg-white rounded-lg border border-gray-200 p-4", className)}>
      <h4 className={cn("font-semibold mb-3 text-center", colorClass)}>{title}</h4>

      {/* Horizontal divider */}
      <hr className="border-gray-300 mb-3" />

      <div className="text-center">
        <p className={cn("text-3xl font-medium", colorClass)}>
          {value}
          {unit && <span className="ms-2 text-lg text-gray-500">{unit}</span>}
        </p>
      </div>
    </div>
  )
}
